import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

export default {
  title: 'Components/Label',
  component: 'a1-label',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Partial Component - To be used with the Form Components.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-label';

const Template = (args: Components.A1Label): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Default: Story<Components.A1Label> = Template.bind({});
Default.args = {
  text: 'Label',
  forInput: 'input-id',
};

export const Optional: Story<Components.A1Label> = Template.bind({});
Optional.args = {
  ...Default.args,
  optionalText: '(optional)',
  optional: true,
};

export const Information: Story<Components.A1Label> = Template.bind({});
Information.args = {
  ...Default.args,
  information: true,
};

export const OptionalInformation: Story<Components.A1Label> = Template.bind({});
OptionalInformation.args = {
  ...Default.args,
  optionalText: '(optional)',
  information: true,
  optional: true,
};
